import { styled } from '@mui/material';
import Button from '../../../components/button/Button';
import { getCompany } from '../../../utils/company';
import { Companies } from '../../../models/domain/enum';

const company = getCompany();

const getContentFormStyles = (theme: any) => {
  switch (company) {
    case Companies.SIRMAN:
      return {
        [theme.breakpointsMediaQuery.down('md')]: {
          paddingTop: theme.spacings.unit(8),
        },
      };
    case Companies.FELSINEA:
      return {
        [theme.breakpointsMediaQuery.down('md')]: {
          padding: `${theme.spacings.unit(14)} 0`,
        },
      };
    default:
      return {};
  }
};

export const Title = styled('h2', {
  shouldForwardProp: (prop) =>
    ![
      'fontSize',
      'fontMobileSize',
      'fontMobileWeight',
      'fontMobileWeight',
    ].includes(prop as string),
})(({ theme, fontSize, fontMobileSize, fontMobileWeight, fontWeight }) => ({
  margin: 0,
  marginTop: theme.fonts.utility.size(6),
  wordBreak: 'break-word',
  textAlign: 'center',
  [theme.breakpointsMediaQuery.up('sm')]: {
    fontSize: fontSize ? `${fontSize}px` : theme.fonts.utility.size(9.5),
    lineHeight: fontSize ? `${fontSize + 4}px` : theme.fonts.utility.size(10.5),
    fontWeight: fontWeight ? (fontWeight as number) : 500,
  },
  [theme.breakpointsMediaQuery.down('sm')]: {
    fontSize: fontMobileSize
      ? `${fontMobileSize}px`
      : theme.fonts.utility.size(11),
    lineHeight: fontMobileSize
      ? `${fontMobileSize + 4}px`
      : theme.fonts.utility.size(11),
    fontWeight: fontMobileWeight ? fontMobileWeight : 500,
  },
}));

export const Description = styled('h3', {
  shouldForwardProp: (prop) =>
    ![
      'fontSize',
      'fontMobileSize',
      'fontMobileWeight',
      'fontMobileWeight',
    ].includes(prop as string),
})(({ theme, fontSize, fontMobileSize, fontMobileWeight, fontWeight }) => ({
  margin: `${theme.spacings.unit(3)} 0 ${theme.spacings.unit(11.25)}`,
  textAlign: 'center',

  [theme.breakpointsMediaQuery.up('sm')]: {
    fontSize: fontSize ? `${fontSize}px` : theme.fonts.utility.size(9),
    lineHeight: fontSize ? `${fontSize + 4}px` : theme.fonts.utility.size(10),
    fontWeight: fontWeight ? (fontWeight as number) : 200,
  },
  [theme.breakpointsMediaQuery.down('sm')]: {
    fontSize: fontMobileSize
      ? `${fontMobileSize}px`
      : theme.fonts.utility.size(10),
    lineHeight: fontMobileSize
      ? `${fontMobileSize + 4}px`
      : theme.fonts.utility.size(10),
    fontWeight: fontMobileWeight ? fontMobileWeight : 200,
  },
}));

export const FormRowGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacings.unit(4),
  marginBottom: theme.spacings.unit(4),
  '& > div > div': {
    minHeight: '1.1rem',
  },
  [theme.breakpointsMediaQuery.up('md')]: {
    flexDirection: 'row',
    alignItems: 'end',
    margin: 0,
    marginBottom: theme.spacings.unit(8),
  },
}));

export const FormBody = styled('div')(({ theme }) => ({
  maxWidth: theme.spacings.unit(156.5),
  margin: 'auto',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const ContentForm = styled('div')(({ theme }) => ({
  paddingTop: theme.spacings.unit(16),
  display: 'flex',
  flexDirection: 'column',
  margin: 'auto',
  maxWidth: theme.spacings.unit(210.5),
  ...getContentFormStyles(theme),
}));

export const ContentLeft = styled('div')(({ theme }) => ({
  width: '100%',
  [theme.breakpointsMediaQuery.up('md')]: {
    width: '45%',
  },
}));

export const ContentRight = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  [theme.breakpointsMediaQuery.up('md')]: {
    justifyContent: 'space-between',
    width: '50%',
  },
}));

export const SubmitButton = styled(Button)(() => ({
  borderRadius: 0,
}));
